import React, { Fragment, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import user3 from "../../assets/images/user/1.jpg";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { useSelector } from "react-redux";
import apiRequest from "../../utils/apiRequest";

const AllBlockedCustomers = () => {
  const [blockedData, setBlockedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [unblockUserModal, setUnblockUserModal] = useState(false);
  const [userToUnblock, setUserToUnblock] = useState(null);
  const token = useSelector((state) => state.auth.userToken);

  const fetchData = async (page) => {
    try {
      setLoading(true);
    
      const response = await apiRequest('get', `${process.env.REACT_APP_API_BASE_URL}/admin/inactive-users`, {}, token);

      setBlockedData(response.data.inactiveUsers);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data: ", error);
      setLoading(false);
    }
  };

  const toggleUnblockUserModal = (user) => {
    setUserToUnblock(user);
    setUnblockUserModal(!unblockUserModal);
  };

  const confirmUnblockUser = async () => {
    try {
      await apiRequest('patch', `${process.env.REACT_APP_API_BASE_URL}/admin/unblock-user/${userToUnblock._id}`, {}, token);
      // Optionally, you can refresh the data after unblocking the user
      fetchData(currentPage);
      setUnblockUserModal(false);
    } catch (error) {
      console.error("Error unblocking user: ", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const customColumns = [
    {
      name: "Profile Picture",
      cell: (row) => (
        <div className="social-img-wrap">
          <div>
            <img
              className="img-60 m-0 rounded-circle"
              src={row.profileImage || user3}
              alt="User"
              style={{ width: "100px" }}
            />
          </div>
        </div>
      ),
      center: false,
    },
    {
      name: "User Name",
      selector: (row) => row["userName"],
      sortable: true,
      center: false,
    },
    {
      name: "Email",
      selector: (row) => row["email"],
      sortable: true,
      center: false,
      minWidth: "200px",
      maxWidth: "300px",
    },
    {
      name: "Location",
      selector: (row) => row["location"],
      sortable: true,
      center: false,
    },
    {
      name: "Unblock User",
      cell: (row) => (
        <Button
          color="success"
          onClick={() => toggleUnblockUserModal(row)}
        >
          Unblock
        </Button>
      ),
      button: true,
      center: true,
      minWidth: "200px",
      maxWidth: "300px",
    },
  ];

  const history = useNavigate();
  const handleViewDetails = (user) => {
    history(`/user-details/${user._id}`);
  };

  return (
    <Fragment>
      <style>
        {`
          .primary-table-header tbody tr:first-of-type td {
            border-top: none;
          }
          .dt-table > .card {
            border: none;
          }
          .dt-table > .card > .card-body {
            padding-top: 0;
          }
        `}
      </style>
      <Breadcrumbs
        mainTitle="All Blocked Customers"
        parent="Dashboard"
        title="All Blocked Customers"
        subtitle="List of all blocked customers"
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <DataTable
              columns={customColumns}
              data={blockedData}
              pagination
              paginationServer
              paginationTotalRows={totalPages * 10}
              paginationPerPage={10}
              paginationDefaultPage={currentPage}
              onChangePage={(page) => setCurrentPage(page)}
              responsive
              striped
              highlightOnHover
              customStyles={{
                rows: {
                  style: {
                    minHeight: "72px",
                  },
                },
                headCells: {
                  style: {
                    paddingLeft: "8px",
                    paddingRight: "8px",
                  },
                },
                cells: {
                  style: {
                    paddingLeft: "8px",
                    paddingRight: "8px",
                  },
                },
              }}
              progressPending={loading}
            />
          </div>
        </div>
      </div>
      <Modal isOpen={unblockUserModal} toggle={toggleUnblockUserModal}>
        <ModalHeader toggle={toggleUnblockUserModal}>Confirm Unblock</ModalHeader>
        <ModalBody>
          Are you sure you want to unblock the user titled "
          {userToUnblock?.userName}"?
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={confirmUnblockUser}>
            Unblock
          </Button>{" "}
          <Button color="secondary" onClick={toggleUnblockUserModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default AllBlockedCustomers;
